import type {
  InvitationListOptions,
  InvitationPage,
  InvitationRepository,
} from '#/domain/invitation/InvitationRepository'

export class GetInvitationListUseCase {
  constructor(private readonly repository: InvitationRepository) {}

  async execute(options?: InvitationListOptions, search?: string): Promise<InvitationPage> {
    return this.repository.findAll(options, search)
  }
}
